import * as React from 'react'
/**
 * @deprecated This file is deprecated and will be removed in the future.
 * Use specific page dependency context or common dependencies from `common.ts`.
 */
export default function createDependenciesScope<D extends object>() {
  const Context = React.createContext<D | null>(null)
  const useDependencies = (): D | null => React.use(Context)
  const useDependency = <N extends keyof D>(name: N): D[N] => {
    const dependencies = useDependencies()

    if (dependencies === null) {
      throw new Error(
        `A dependency has beend attempted to be retrieved without Provider initialization: ${String(name)}`,
      )
    }

    return dependencies[name]
  }

  return {
    Provider: ({ dependencies, children }: React.PropsWithChildren<{ dependencies: D }>) => (
      <Context value={dependencies}>{children}</Context>
    ),
    useDependency,
    useDependencies,
  }
}
